import { render, staticRenderFns } from "./AcademicGoalProgress.vue?vue&type=template&id=649cdbcd&scoped=true"
import script from "./AcademicGoalProgress.vue?vue&type=script&lang=js"
export * from "./AcademicGoalProgress.vue?vue&type=script&lang=js"
import style0 from "./AcademicGoalProgress.vue?vue&type=style&index=0&id=649cdbcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649cdbcd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
